import {
  TViewPortRanking,
  TViewPortRankingResponse,
  ViewPortSizeVariationEnum,
} from "domain/entities/view-port-ranking-response";

export type TTraficSourceSummaryTableHead = {
  header: string;
  accessor: string;
};

export type TTraficSourceSummaryTableBody = {
  mediaType: string;
  vehicle: string;
  title: string;
  visitors: string;
  conversion: string;
};

export class ViewportRankingModel {
  static from(
    viewportRankingResponse: TViewPortRankingResponse
  ): TViewPortRanking {
    return {
      range: viewportRankingResponse.range,
      cards: viewportRankingResponse.cards,
      viewPortRanking: {
        dataColumns: [
          {
            header: "Screen size",
            accessor: "viewPortSize",
          },
          {
            header: "Unique visitors",
            accessor: "visitors",
          },
          {
            header: "Converted",
            accessor: "converted",
          },

          {
            header: "Bounced",
            accessor: "bounced",
          },
        ],
        dataRows: viewportRankingResponse.viewportRankingTable.map(
          (viewport) => {
            return {
              viewPortSize: viewport.screenResolution as ViewPortSizeVariationEnum,
              converted: `${viewport.nConversions} (${viewport.percentageConversions})`,
              visitors: `${viewport.nVisitors} (${viewport.percentageVisitors})`,
              bounced: `${viewport.nBounces} (${viewport.percentageBounces})`,
            };
          }
        ),
      },
    };
  }
}
